// ErrorComponent.jsx (react-router-dom v4/v5 compatible)
import React from "react";
import { Link, withRouter } from "react-router-dom";

function ErrorComponent({
  title = "Sorry—something went wrong.",
  message = "An unexpected error occurred. Please try again. If the issue persists, please report it.",
  errorId,          // optional: trace/correlation id
  details,          // optional: stack or error message
  onRetry,          // optional: callback to retry previous action
  location          // injected by withRouter
}) {
  const from = `${location?.pathname || "/"}${location?.search || ""}`;
  const contactSearch =
    `?subject=Error%20Report` +
    (errorId ? `&errorId=${encodeURIComponent(errorId)}` : "") +
    `&from=${encodeURIComponent(from)}`;

  const mailtoHref =
    `mailto:info@techventurellc.com` +
    `?subject=Error%20Report` +
    (errorId ? `&body=Error%20ID:%20${encodeURIComponent(errorId)}%0AFrom:%20${encodeURIComponent(from)}` : "");

  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert("Copied to clipboard.");
    } catch {}
  };

  return (
    <div className="container py-5" role="alert" aria-live="polite">
      <div className="row justify-content-center">
        <div className="col-12 col-md-10 col-lg-8">
          <div className="card shadow-sm border-0">
            <div className="card-body text-center p-4 p-md-5">
              <div className="display-6 mb-2" aria-hidden="true">🙇‍♂️</div>
              <h1 className="h4 mb-2">{title}</h1>
              <p className="text-muted mb-4">{message}</p>

              {errorId && (
                <div className="alert alert-light border d-flex align-items-center justify-content-between text-start">
                  <div className="small m-0">
                    <strong>Error ID:</strong>{" "}
                    <code className="ms-1">{errorId}</code>
                  </div>
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => copy(errorId)}
                  >
                    Copy
                  </button>
                </div>
              )}

              {details && (
                <details className="text-start mb-3">
                  <summary className="small text-muted">Technical details</summary>
                  <pre className="mt-2 p-3 bg-light rounded border small" style={{ overflow: "auto" }}>
                    {String(details)}
                  </pre>
                </details>
              )}

              <div className="d-flex flex-wrap gap-2 justify-content-center">
                {onRetry && (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={onRetry}
                    aria-label="Try the previous action again"
                  >
                    Try again
                  </button>
                )}
                <Link
                  to={{ pathname: "/contactUs", search: contactSearch, state: { from, subject: "Error report", errorId } }}
                  className="btn btn-dark"
                  aria-label="Go to Contact Us page to report this error"
                >
                  Contact Us & report issue
                </Link>
                <Link to="/" className="btn btn-outline-secondary" aria-label="Go back to homepage">
                  Go to Home
                </Link>
              </div>

              <p className="small text-muted mt-3 mb-0">
                Prefer email? Write to{" "}
                <a href={mailtoHref}>info@techventurellc.com</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default withRouter(ErrorComponent);
